import { bunja } from 'bunja';
import { v4 as uuid } from 'uuid';

import { refPositionTimes } from '@flipster/r230522/original/server-time';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { dateToEpochString } from '@flipster/utils/datetime';

import { orderAttributionAtom } from '../order-attribution';

/**
 * requestId + timestamp만 — attribution을 오늘도 보내지 않는 경로용
 * (예: close-all의 MultiplePositions 경로, deleteAllTpslOrdersApi).
 * base 헬퍼가 "친절하게" 필드를 추가하면 동작 보존이 깨지므로 2단으로 분리한다.
 */
export const buildRequestStamp = (): { requestId: string; timestamp: string } => ({
  requestId: uuid(),
  timestamp: dateToEpochString(new Date()),
});

/**
 * 표준 trade 요청 base: stamp + attribution.
 * (chart-order-drag의 기존 getBaseParams와 동일한 형태 — ad-hoc 조립을 이 한 곳으로 수렴)
 */
export const buildTradeRequestBase = (
  attribution: string | undefined,
): { requestId: string; timestamp: string; attribution: string | undefined } => ({
  ...buildRequestStamp(),
  attribution,
});

/**
 * trade-actions 공용 base-params 데이터 레이어.
 * attribution은 orderAttributionAtom에서 호출 시점에 읽는다(스냅샷 아님).
 * refPositionTimes 스프레드는 오늘 그것을 보내는 API에만 명시적으로 쓴다 — 암묵 추가 금지.
 */
export const tradeRequestBaseBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);

  const getBase = () => buildTradeRequestBase(store.get(orderAttributionAtom));
  const getBaseWithRefTimes = (symbol: string) => ({ ...getBase(), ...refPositionTimes[symbol] });

  return { getBase, getBaseWithRefTimes };
});
tradeRequestBaseBunja.debugLabel = 'tradeRequestBaseBunja';
